import { render, staticRenderFns } from "./PaymentIntegrity.vue?vue&type=template&id=ecc1b8d8&scoped=true"
import script from "./PaymentIntegrity.vue?vue&type=script&lang=ts"
export * from "./PaymentIntegrity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc1b8d8",
  null
  
)

export default component.exports